var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgInfoIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 2,
    height: 9,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.352 1.395A.61.61 0 01.741.784c0-.351.273-.624.611-.624.351 0 .624.273.624.624a.613.613 0 01-.624.611zM.923 8.753V4.047c0-.13.117-.247.247-.247h.403c.13 0 .247.117.247.247v4.706c0 .13-.117.247-.247.247H1.17a.256.256 0 01-.247-.247z",
    fill: "#185674"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgInfoIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "info-icon.2bb6ac57c3f70e574504e999c14097d5.svg";